import { Routes, Route } from 'react-router-dom';
import { AuthWrapper } from '@/components/auth/AuthWrapper';
import { AppLayout } from '@/components/layout/AppLayout';
import { DashboardPage } from '@/pages/Dashboard';
import { InterviewPage } from '@/pages/Interview';
import { InterviewBuilder } from '@/pages/InterviewBuilder';
import { RespondPage } from '@/pages/Respond';
import { ResultsPage } from '@/pages/Results';

function App() {
  return (
    <AuthWrapper>
      <AppLayout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          {/* New Interview Platform Routes */}
          <Route path="/interviews/new" element={<InterviewBuilder />} />
          <Route path="/interviews/:id/edit" element={<InterviewBuilder />} />
          <Route path="/interviews/:id/results" element={<ResultsPage />} />
          <Route path="/respond/:token" element={<RespondPage />} />
          {/* Legacy Route - kept for backwards compatibility */}
          <Route path="/interview/:sessionId" element={<InterviewPage />} />
        </Routes>
      </AppLayout>
    </AuthWrapper>
  );
}

export default App;
